<div class="col-12 navformul">
  <div class="row  justify-content-center">

    <h2 class="col-12 titleBookk"><b>{{ 'FORMULE.TITLE' | translate }}</b></h2>


    <div *ngIf="isLoad; then BilanBlock else BilanNullBlock"></div>
    <ng-template #BilanBlock>


      <div *ngIf="currentUser.contract?.package_name" class="col-lg-3 col-12 serviceformule">
        <div class="round-img-large box-shadow eco-info">
          <h5>
              <img  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Porte-monnaie.svg"/>
          </h5>
          <h6 >{{ 'FORMULE.FORMULE0' | translate }}</h6>
          <label>  {{currentUser.contract.package_name}}
          </label>
        </div>

      </div>
     
     
      <div class="col-lg-3 col-12 serviceformule">
        <div class="round-img-large box-shadow eco-info">
          <h5>
              <img  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Pieces.svg"/>
          </h5>
          <h6 >{{ 'FORMULE.FORMULE1' | translate }}</h6>
          <label> {{microTranslate[currentUser.paymode]}}
          </label>
        </div>

      </div>

      <div class="col-lg-3 col-12 serviceformule">
        <div class="round-img-large box-shadow eco-info">
          <h5>
              <img   style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Volant.svg"/>
          </h5>
          <h6>{{ 'FORMULE.FORMULE2' | translate }}</h6>
          <label> 
            {{currentUser.contract.allowed_drivers}}
          </label>
        </div>

      </div>
      <div class="col-lg-3 col-12 serviceformule">
        <div class="round-img-large box-shadow eco-info">
          <h5>
              <img   style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Contrat.svg"/>
          </h5>
          <h6>{{ 'FORMULE.FORMULE3' | translate }}</h6>
          <label>
            {{beginningDate | date : "dd/MM/yyyy"}}

          </label>
        </div>

      </div>
    </ng-template>

<div class="d-flex justify-content-center mt-5 mb-5" *ngIf="currentUser?.territory">
  <mat-card style="border-radius: 15px" class="col-8">
    <mat-card-content class="text-center p-4">
      Vous êtes inscrit sur la communauté <strong style="color: black;">{{ currentUser?.community?.name }}</strong>,
      et avez souscrit à la formule <strong>{{ currentUser?.contract?.package_name }}</strong>.
      Vous avez également accès aux stations de communautés partenaires,
      sur lesquels les formules FLEX (standard) s’appliquent.
      Pour consulter les modalités des stations partenaires,
      rendez-vous sur <a [href]="getUrlInform(currentUser?.territory)" >S’informer-aide</a>.
    </mat-card-content>
  </mat-card>
</div>


<div class="d-flex justify-content-center mt-5 mb-5" *ngIf="currentUser">
  <div style="border-radius: 15px" class="col-8">
    <div class="text-center p-4">


       <div class="row justify-content-center pb-4">
      <div class="col-12 usagers-row">
        <div class="usagers-badge">
          <span class="usagers-nombre">{{ currentUser?.total_comunity_drivers }}</span>
          <span class="usagers-label">usagers inscrits sur cette communauté</span>
        </div>
      </div>
    </div>


  </div>

   
</div>
</div>


    <ng-template #BilanNullBlock>
      
      <div class="row justify-content-center mt-4">
        <mat-spinner class="mt-5" strokeWidth="19" [diameter]="100" color="primary"></mat-spinner>
      </div>

    </ng-template>
  </div>
</div>
